import { render } from "./ComicReader.vue?vue&type=template&id=6436e9d0&scoped=true"
import script from "./ComicReader.vue?vue&type=script&lang=js"
export * from "./ComicReader.vue?vue&type=script&lang=js"

import "./ComicReader.vue?vue&type=style&index=0&id=6436e9d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6436e9d0"]])

export default __exports__